export const unassigned_option = (label: string) => ({
  id: 'unassigned',
  label,
  userfullname: label,
  weight: 'bold',
});
